type GetNextOrderRangeParams = {
    selectedDate: Date;
    minDeliveryDaysCount?: number;
    maxDeliveryDaysCount?: number;
    excludeWeekends: boolean;
    weekendDaysNumbers: number[];
};

const addDays = (date: Date, days: number): Date => {
    const resultDate = new Date(date);

    return new Date(resultDate.setDate(resultDate.getDate() + days));
};

const addBusinessDays = (date: Date, days: number, excludedDays: number[]): Date => {
    if (days <= 0) {
        return new Date(date);
    }

    let remainingDays = days;
    const resultDate = new Date(date);

    while (remainingDays > 0) {
        resultDate.setDate(resultDate.getDate() + 1);

        if (!excludedDays.includes(resultDate.getDay())) {
            remainingDays -= 1;
        }
    }

    return resultDate;
};

const normalizeDeliveryDays = (value: number | undefined, fallback: number): number =>
    Number.isFinite(value) ? Math.max(0, Math.trunc(value!)) : fallback;

export const getNextOrderRange = ({
    selectedDate,
    minDeliveryDaysCount,
    maxDeliveryDaysCount,
    excludeWeekends,
    weekendDaysNumbers,
}: GetNextOrderRangeParams): {minDate: Date; maxDate: Date} => {
    const minDays = normalizeDeliveryDays(minDeliveryDaysCount, 0);
    const maxDays = normalizeDeliveryDays(maxDeliveryDaysCount, minDays);

    return {
        minDate: excludeWeekends
            ? addBusinessDays(selectedDate, minDays, weekendDaysNumbers)
            : addDays(selectedDate, minDays),
        maxDate: excludeWeekends
            ? addBusinessDays(selectedDate, maxDays, weekendDaysNumbers)
            : addDays(selectedDate, maxDays),
    };
};
